module.exports = __webpack_public_path__ + "img/工厂_factory-building-2.1968273f.svg";